import React from 'react';
import Chart from 'react-apexcharts';
const BarGraph = ({ graphData, totalAmount }) => {
  const stateData = [{}];
  let seriesNew = [];
  let colorNew = [];
  if (totalAmount === 0) {
    seriesNew?.push({
      name: 'NA',
      data: [100],
    });
    colorNew.push(['#0B243F']);
    return false;
  }
  if (Number(totalAmount) > 0) {
    graphData?.forEach((element) => {
      if (element?.final_amount > 0) {
        seriesNew.push({
          name: element?.name,
          data: [element?.final_amount],
        });
        colorNew.push('#' + element?.color);
      }
    });
  }

  stateData.push({
    series: seriesNew,
    options: {
      colors: colorNew,
      xaxis: {
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        labels: {
          show: true,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      grid: {
        show: false,
      },
      chart: {
        type: 'bar',
        height: 100,
        stacked: true,
        stackType: '100%',
        toolbar: {
          show: false,
        },
        selection: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: true,
        },
      },
      tooltip: {
        enabledOnSeries: false,
        x: {
          show: false,
        },
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
      fill: {
        opacity: 1,
      },
      legend: {
        show: false,
      },
    },
  });
  return (
    <>
      <Chart
        options={{
          ...stateData[1]?.options,
          plotOptions: {
            bar: {
              ...stateData[1]?.options.plotOptions?.bar,
              offsetX: 0,
            },
          },
        }}
        series={stateData[1]?.series}
        type="bar"
        height={120}
      />
    </>
  );
};

export default BarGraph;
